import React from "react";

export default class DataFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }

        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filter(event) {
        this.setState({value: event.target.value})
        if (this.refs.dataInput.value === '') {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }
    }

    isFiltered(targetValue) {
        if ((targetValue.substr(0,10) + ' ' + targetValue.substr(11,5)).indexOf(this.refs.dataInput.value) >= 0 ) {
            return targetValue
        }
    }

    render() {
        return (
            <div>
                <input ref='dataInput' type='text' className='form-control' placeholder='Szukaj'
                       value={this.state.value} onChange={this.filter}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/filters/DataFilter.js